import { BoundTextField } from "lib/@components/binding/bound-components"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function AssetDisplayField({ item: { field } }) {
    const { target } = useBoundContext()
    return (
        (!!target[field] || target[field] === 0) && (
            <BoundTextField
                variant="standard"
                size="small"
                InputProps={{ disableUnderline: true, readOnly: true }}
                field={field}
            />
        )
    )
}
